export class AccountConsumption {
    consumptionYear: number|null = null;
    consumptionMonth: number|null = null;
    consumptionDay: number|null = null;
    isEstimated: boolean|null = null;
    consumption: number|null = null;
}
